import { Box, Drawer, Stack } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// import { BuyNow } from 'src/components/CabalPlusCTA/BuyNow';
import { CabalVoice } from 'src/components/CabalVoice';
import Logo from 'src/components/Logo';
// import { CabalWSGroupCTA } from 'src/components/CabalWSGroupCTA';
import Scrollbar from 'src/components/Scrollbar';
import { NavSectionVertical } from 'src/components/nav-section';
import { NAVBAR } from 'src/config';
// import { CabalPlusGuard } from 'src/guards/CabalPlusGuard';
import useCollapseDrawer from 'src/hooks/useCollapseDrawer';
import { useRemoteConfig } from 'src/hooks/useRemoteConfig';
// import { usePermissions } from 'src/hooks/usePermissions';
import useResponsive from 'src/hooks/useResponsive';
// import { useSubscription } from 'src/hooks/useSubscription';
import cssStyles from 'src/utils/cssStyles';

import CollapseButton from './CollapseButton';
import NavbarAccount from './NavbarAccount';
import { useNavConfig } from './useNavConfig';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

// ----------------------------------------------------------------------

type Props = {
  isOpenSidebar: boolean;
  onCloseSidebar: VoidFunction;
};

export default function NavbarVertical({
  isOpenSidebar,
  onCloseSidebar,
}: Props) {
  const theme = useTheme();
  const navConfig = useNavConfig();
  const { pathname } = useLocation();
  const { getRemoteSetting } = useRemoteConfig();
  const enableAi = getRemoteSetting('show_ai');

  // const { is } = usePermissions();
  // const { is: isSub } = useSubscription();

  const isDesktop = useResponsive('up', 'lg');

  const {
    isCollapse,
    collapseClick,
    collapseHover,
    onToggleCollapse,
    onHoverEnter,
    onHoverLeave,
  } = useCollapseDrawer();

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
          ...(isCollapse && { alignItems: 'center' }),
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Logo small={isCollapse} />

          {isDesktop && !isCollapse && (
            <CollapseButton
              onToggleCollapse={onToggleCollapse}
              collapseClick={collapseClick}
            />
          )}
        </Stack>

        <NavbarAccount isCollapse={isCollapse} />
      </Stack>

      {/* {is('owner') && isSub('active_subscription') ? ( */}
      {/*   <CabalPlusGuard> */}
      {/*     <CabalWSGroupCTA isCollapse={isCollapse} /> */}
      {/*   </CabalPlusGuard> */}
      {/* ) : ( */}
      {/*   <BuyNow /> */}
      {/* )} */}

      {enableAi && <CabalVoice isCollapse={isCollapse} />}

      <NavSectionVertical navConfig={navConfig} isCollapse={isCollapse} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse
            ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH
            : NAVBAR.DASHBOARD_WIDTH,
        },
        ...(collapseClick && {
          position: 'absolute',
        }),
      }}
    >
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{ sx: { width: NAVBAR.DASHBOARD_WIDTH } }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          onMouseEnter={onHoverEnter}
          onMouseLeave={onHoverLeave}
          PaperProps={{
            sx: {
              width: NAVBAR.DASHBOARD_WIDTH,
              borderRightStyle: 'dashed',
              bgcolor: 'background.default',
              transition: (theme) =>
                theme.transitions.create('width', {
                  duration: theme.transitions.duration.standard,
                }),
              ...(isCollapse && {
                width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
              }),
              ...(collapseHover && {
                ...cssStyles(theme).bgBlur(),
                boxShadow: (theme) => theme.customShadows.z24,
              }),
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
